export const uiImageList = {
    name: 'UI Image List',
    description: '',
    displayField: null,
    fields: {
        images: {
            name: 'Images',
            type: 'Array',
            required: true,
            localized: false,
            disabled: false,
            omitted: false,
            validations: [{ size: { min: 1 } }],
            items: {
                type: 'Link',
                validations: [{ linkMimetypeGroup: ['image'] }],
                linkType: 'Asset'
            }
        }
    }
};
//# sourceMappingURL=uiImageList.js.map